function selectSecondOption(chipsWrapper) {
  const allChipsWrapper = chipsWrapper || document.querySelectorAll('.product__color-chips');
  allChipsWrapper.forEach(function (chipGroup) {
      const productContainer = chipGroup.closest('[data-section-type="product"]');
      const variantWrapper = chipGroup.closest('.product__variants-wrapper:has([data-option-value="Single 4 Pack"]');
      const allChipsElem = chipGroup.querySelectorAll('.product__chip');
      const singleFourPackChip = chipGroup.querySelector('[data-option-value="Single 4 Pack"].selected');
      const singleFourPackChipIndex = Array.from(allChipsElem).indexOf(singleFourPackChip);

      if (singleFourPackChipIndex !== -1) {
          singleFourPackChip.style.display = 'none';
          variantWrapper && (variantWrapper.style.display = 'block');
          const nextChipIndex = singleFourPackChipIndex + 1;
          if (nextChipIndex < allChipsElem.length) {
              allChipsElem[nextChipIndex].click();
              const selectElement = chipGroup.querySelector('select');
              selectElement.value = allChipsElem[nextChipIndex].getAttribute('data-option-value');
              selectElement.dispatchEvent(new Event('change'));
          }
      }

      if (variantWrapper) variantWrapper.style.display = 'block';
      if (productContainer.querySelector('.product-form')) productContainer.querySelector('.product-form').style.display = 'block';
  });
}

window.selectSecondOption = selectSecondOption;

function observeRechargeWidget() {
  const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
          if (mutation.type === 'childList') {
              const rechargeElement = document.querySelector('.rc-radio__label');
              if (rechargeElement) {
                  console.log('Recharge app is loaded.');
                  document.querySelector('.recharge-subscription-widget.shopify-block .rc-widget').style.display = 'none';
                  setTimeout(() => {
                      window.selectSecondOption();
                      document.querySelector('.recharge-subscription-widget.shopify-block .rc-widget').style.display = 'block';
                  }, 100);
                  observer.disconnect(); // Stop observing once detected
              }
          }
      });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

function checkRechargeLoaded(maxAttempts = 10, intervalTime = 500) {
  let attempts = 0;

  const interval = setInterval(() => {
      const rechargeElement = document.querySelector('.rc-radio__label');

      if (rechargeElement) {
          console.log('Recharge app is loaded (Interval Fallback).');
          window.selectSecondOption();
          clearInterval(interval);
      } else if (attempts >= maxAttempts) {
          console.log('Recharge app was not detected after max attempts.');
          clearInterval(interval);
      }

      attempts++;
  }, intervalTime);
}

// To check if recharge widget is auto injected or not
function observeRechargeWidgetAutoInjected() {
  const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
          if (mutation.type === 'childList') {
              const rechargeElement = document.querySelector('.rc-container-wrapper');
              if (rechargeElement) {
                  console.log('Recharge app is auto injected.');
                  rechargeElement.remove(); // Remove the auto injected widget
                  observer.disconnect(); // Stop observing once detected
              }
          }
      });
  });

  observer.observe(document.querySelector('[data-section-type="product"] .product__meta .product-form'), { childList: true, subtree: true });
}
// End for check auto injected recharge widget

// Handle dynamic section loads
// document.addEventListener('shopify:section:load', function(event) {
//   if (window.location.href.includes('/products/')) {
//       if (event.target.querySelector('.product__color-chips')) {
//           setTimeout(() => selectSecondOption(), 500);
//       }
//   }
// });

// Fallback for initial page load
document.addEventListener('DOMContentLoaded', function() {
  if (window.location.href.includes('/products/')) {
    if (document.querySelector('.shopify-app-block.recharge-subscription-widget')) {
        observeRechargeWidget(); // Primary method using MutationObserver
        setTimeout(() => checkRechargeLoaded(), 1000); // Fallback interval
    } else {
        if (window.location.href.includes('/products/')) {
            observeRechargeWidgetAutoInjected();
            if (document.querySelector('.product__color-chips')) {
                setTimeout(() => selectSecondOption(), 500);
            }
        }
    }
  }
  console.log(document.querySelector('.shopify-app-block.recharge-subscription-widget'))
});



// Remove first "Single 4 Pack" logic for Slidecarthq
// No need to run this logic as we are showing only recharge bundle products which does not have "Single 4 Pack" option.
// function observeAllChanges(targetElement) {
//   const observer = new MutationObserver((mutations) => {
//     let shouldRunLogic = false;
//       mutations.forEach(mutation => {
//         // console.log('Mutation:', mutation);
//           if (mutation.type === 'childList') {
//               mutation.addedNodes.forEach(node => {
//                 if (node.nodeType === 1 && node.classList.contains('slick-slide')) {
//                     shouldRunLogic = true;
//                 }
//               });

//             mutation.removedNodes.forEach(node => {
//                 if (node.nodeType === 1 && node.classList.contains('slick-slide')) {
//                     shouldRunLogic = true;
//                 }
//               });
//             } else if (mutation.type === 'attributes') {
//               if (mutation.target.classList.contains('slidecarthq')) {
//                 shouldRunLogic = true;
//               }
//             }
//       });
//       if (shouldRunLogic) runUpsellLogic();
//   });

//   observer.observe(targetElement, {
//       childList: true,     // Detect child elements added/removed
//       subtree: true,        // Observe the entire subtree
//       attributes: true,    // Detect attribute changes
//       characterData: false  // Don't detect changes to node data
//   });
// }

// function checkSlidecartLoaded(maxAttempts = 200, intervalTime = 100) {
//     let attempts = 0;
//     const interval = setInterval(() => {
//         const upsells = document.querySelector('#slidecarthq .slidecarthq');
//         if (window.SLIDECART && upsells) {
//             runUpsellLogic();

//             // Start observing `#slidecarthq` or fallback to `body` if it's dynamically added
//             const targetElement = document.querySelector('#slidecarthq .slidecarthq');
//             observeAllChanges(targetElement);

//             clearInterval(interval);
//         } else if (attempts >= maxAttempts) {
//             clearInterval(interval);
//         }
//         attempts++;
//     }, intervalTime);
// }

// function runUpsellLogic() {
//     const selectsUpsell = [...document.querySelectorAll('#slidecarthq .upsell-options select')];
//     console.log('selectsUpsell', selectsUpsell);
//     selectsUpsell.forEach(select => {
//         const firstOption = select.querySelector('option:nth-child(1)');
//         if (firstOption && firstOption.text.trim().includes("Single 4 Pack")) {
//             firstOption.remove();
//         }

//         const secondOption = select.querySelector('option:nth-child(1)');
//         if (secondOption) {
//             secondOption.classList.add('cf1');
//             select.value = secondOption.value;
            
//             console.log('Triggering change event on select.', select);
//             select.dispatchEvent(new Event('change', { bubbles: true }));
//         }
//     });
// }

// checkSlidecartLoaded();
// window.checkSlidecartLoaded = checkSlidecartLoaded;

// Remove first "Single 4 Pack" logic for Slidecarthq ends


// Shipping progress bar in AMP side cart
// async function getCartPageHtml() {
//   try {
//     const response = await fetch(theme.routes.cart.base + '?section_id=main-cart'); // Make a GET request to the /cart endpoint
    
//     if (!response.ok) {
//       throw new Error(`HTTP error! status: ${response.status}`);
//     }
    
//     const cartHtml = await response.text();
//     const cartHtmlParsed = new DOMParser().parseFromString(cartHtml, 'text/html');
//     // window.freeShippingBar(cartHtmlParsed.querySelector('.free-shipping-bar'));
//     return cartHtmlParsed;
//   } catch (error) {
//     console.error('Error fetching cart page HTML:', error);
//     return null;
//   }
// }
// window.SLIDECART_LOADED = async function(cartData) {
//     const cartHtml = await getCartPageHtml();
//   // Fires once the cart has loaded
//     console.log(cartHtml, 'cartHtml')
//     const slidecartElement = document.querySelector('#slidecarthq [data-free-shipping-bar-custom]');
//     const shippingProgressHTML = cartHtml.querySelector('[data-free-shipping-bar]');
//     if (slidecartElement && shippingProgressHTML) {
//         slidecartElement.innerHTML = shippingProgressHTML.outerHTML;
//         window.freeShippingBar(slidecartElement.querySelector('[data-free-shipping-bar]'));
//     }
// }

window.SLIDECART_UPDATED = async function(cartData) {
    const cartHtml = document.getElementById('free-shipping-bar-template').content;
    const clonedContent = document.importNode(cartHtml, true);
  // Fires once the cart has loaded
    console.log(clonedContent, 'clonedContent')
    const slidecartElement = document.querySelector('#slidecarthq [data-free-shipping-bar-custom]');
    const shippingProgressHTML = clonedContent.querySelector('[data-free-shipping-bar]');
    if (slidecartElement && shippingProgressHTML) {
        shippingProgressHTML.setAttribute('data-cart-total', cartData.total_price);
        slidecartElement.innerHTML = shippingProgressHTML.outerHTML;
        // slidecartElement.querySelector('[data-free-shipping-bar]').classList.remove('free-shipping-bar--loaded');
        window.freeShippingBar(slidecartElement.querySelector('[data-free-shipping-bar]'));
        const event = new CustomEvent('apps:product-added-to-cart');
        document.dispatchEvent(event);
        // const event = new CustomEvent("cart:updated", {
        //     detail: { cart: cartData }
        // });
        // document.dispatchEvent(event);
    }
}